import moment from "moment";


export function formatY(y) {

    let str = `${y}`

    if (y >= 100000) return str.substr(0, 3) + "к"
    if (y >= 10000) return str.substr(0, 2) + "к"
    if (y >= 1000) return str.substr(0, 1) + "к"

    return y
}